export var DeliveryNoteStatus;
(function (DeliveryNoteStatus) {
    DeliveryNoteStatus["PENDING"] = "pending";
    DeliveryNoteStatus["EXTRACTING"] = "extracting";
    DeliveryNoteStatus["PROCESSED"] = "processed";
    DeliveryNoteStatus["VALIDATED"] = "validated";
    DeliveryNoteStatus["ERROR"] = "error";
    DeliveryNoteStatus["DELETED"] = "deleted";
    DeliveryNoteStatus["AWAITING_QUOTA"] = "awaitingQuota";
})(DeliveryNoteStatus || (DeliveryNoteStatus = {}));
// Delivery notes in any of these statuses are relevant for the system, they are used in queries and calculations.
export const ACTIVE_DELIVERY_NOTE_STATUSES = [
    DeliveryNoteStatus.PENDING,
    DeliveryNoteStatus.PROCESSED,
    DeliveryNoteStatus.EXTRACTING,
    DeliveryNoteStatus.VALIDATED,
    DeliveryNoteStatus.AWAITING_QUOTA,
];
/** Active notes that still occupy a slot but are not yet validated (excludes error/deleted). */
export const PENDING_VALIDATION_DELIVERY_NOTE_STATUSES = [
    DeliveryNoteStatus.PENDING,
    DeliveryNoteStatus.EXTRACTING,
    DeliveryNoteStatus.PROCESSED,
];
/** Statuses from which extraction may claim the document. */
export const CLAIMABLE_DELIVERY_NOTE_STATUSES = [
    DeliveryNoteStatus.PENDING,
    DeliveryNoteStatus.AWAITING_QUOTA,
    DeliveryNoteStatus.ERROR,
];
export const isAwaitingQuotaStatus = (status) => status === DeliveryNoteStatus.AWAITING_QUOTA;
export const defaultDeliveryNoteData = {
    deliveryNoteIngredients: [],
    imagePaths: [],
    batchId: '',
    status: DeliveryNoteStatus.PENDING,
    organizationId: '',
    totalExpense: 0,
    hasIssues: false,
    deliveryNoteIngredientsIds: [],
    deliveryNoteId: '',
    isPaid: false,
    isInvoiceUsedAsDeliveryNote: false,
};
//# sourceMappingURL=DeliveryNoteEntity.js.map